import React, { useEffect } from 'react';
import { useSanityData } from '../hooks/useSanityData';
import { urlFor } from '../sanityClient';

// Photo gallery with Slick slider + Bootstrap modal lightbox.
// `source` can be 'inline' (photos field) or 'performance' (resolved reference).
export default function PhotoGallery({ source = 'inline', performance, photos: inlinePhotos = [], photoCredit }) {
  const lang = localStorage.getItem('language') || 'arm';

  // When source is 'performance', fetch photos from the referenced performance
  const perfQuery = source === 'performance' && performance
    ? `*[_type == "performance" && _id == $id][0]{ photos, photoCredit }` : null;
  const { data: perfData } = useSanityData(perfQuery, { id: performance?._ref || '' });

  const photos = source === 'performance'
    ? (perfData?.photos || [])
    : inlinePhotos;

  const credit = source === 'performance'
    ? (perfData?.photoCredit ? (perfData.photoCredit[lang] || perfData.photoCredit.en || '') : '')
    : (photoCredit ? (photoCredit[lang] || photoCredit.en || '') : '');

  // Initialize Slick after mount
  useEffect(() => {
    if (photos.length === 0) return;
    const $ = window.jQuery;
    if (!$) return;
    setTimeout(() => {
      if (!$('.slider-for').hasClass('slick-initialized')) {
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav',
        });
        $('.slider-nav').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          dots: false,
          centerMode: true,
          focusOnSelect: true,
        });
      }
    }, 100);
  }, [photos]);

  if (photos.length === 0) return null;

  return (
    <section className='photo-gallery-section'>
      <div className='slider-for'>
        {photos.map((photo, i) => {
          const src = urlFor(photo).width(900).url();
          return (
            <div key={i}>
              <img
                src={src}
                alt={`gallery-${i}`}
                className='img-fluid gallery-main-img'
                data-toggle='modal'
                data-target='#galleryModal'
                style={{ cursor: 'pointer' }}
              />
            </div>
          );
        })}
      </div>
      <div className='slider-nav gallery-thumbs'>
        {photos.map((photo, i) => {
          const src = urlFor(photo).width(200).url();
          return (
            <div key={i}>
              <img src={src} alt={`thumb-${i}`} className='img-fluid gallery-thumb' />
            </div>
          );
        })}
      </div>
      {credit && <p className='photo-credit text-center mt-2'>{credit}</p>}

      {/* Bootstrap modal lightbox */}
      <div className='modal fade' id='galleryModal' tabIndex='-1' role='dialog' aria-hidden='true'>
        <div className='modal-dialog modal-xl modal-dialog-centered' role='document'>
          <div className='modal-content bg-transparent border-0'>
            <div className='modal-body p-0'>
              <div id='galleryCarousel' className='carousel slide' data-ride='carousel'>
                <div className='carousel-inner'>
                  {photos.map((photo, i) => {
                    const src = urlFor(photo).width(1200).url();
                    return (
                      <div className={`carousel-item${i === 0 ? ' active' : ''}`} key={i}>
                        <img src={src} alt={`lightbox-${i}`} className='d-block w-100' />
                      </div>
                    );
                  })}
                </div>
                <a className='carousel-control-prev' href='#galleryCarousel' role='button' data-slide='prev'>
                  <span className='carousel-control-prev-icon' aria-hidden='true' />
                </a>
                <a className='carousel-control-next' href='#galleryCarousel' role='button' data-slide='next'>
                  <span className='carousel-control-next-icon' aria-hidden='true' />
                </a>
              </div>
            </div>
            <button type='button' className='close text-white' data-dismiss='modal' aria-label='Close'
              style={{ position: 'absolute', top: 10, right: 15, fontSize: 32 }}>
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
